import React from 'react';
import { getScoreBadgeClass } from '../../utils/scoreTier';
import './ScoreBadge.css';

interface ScoreBadgeProps {
  score: number | null | undefined;
  digits?: number;
  large?: boolean;
}

export const ScoreBadge: React.FC<ScoreBadgeProps> = ({ score, digits = 1, large }) => {
  const label = score === null || score === undefined || !Number.isFinite(Number(score))
    ? '—'
    : Number(score).toFixed(digits);
  return (
    <span className={`score-badge ${getScoreBadgeClass(score)}${large ? ' score-badge--large' : ''}`}>
      {label}
    </span>
  );
};

export default ScoreBadge;
